import { handlePromise } from "../apiControllers/helpers";
import Env from "../../Environments";
import { apiUrls } from "../../constants/apiUrls";

export const getScmOrganisations = async (headers) => {
  const apiPayload = {
    method: "GET",
    headers,
    url: Env.getTeamCommonUrl() + apiUrls.getScmOrganisations,
  };

  return handlePromise(apiPayload);
};

export const getScmLocations = async (headers) => {
  const apiPayload = {
    method: "GET",
    headers,
    url: Env.getTeamCommonUrl() + apiUrls.getScmLocations,
  };

  return handlePromise(apiPayload);
};

export const createScmOrder = async (payload) => {
  const apiPayload = {
    method: "POST",
    data: payload,
    url: Env.getTeamCommonUrl() + apiUrls.createScmOrder,
  };

  return handlePromise(apiPayload);
};

export const getCartDetails = async (params) => {
  const apiPayload = {
    method: "GET",
    params,
    url: Env.getTeamCommonUrl() + apiUrls.getScmCartDetails,
  };

  return handlePromise(apiPayload);
};

export const saveScmCart = async (data) => {
  const apiPayload = {
    method: "POST",
    data,
    url: Env.getTeamCommonUrl() + apiUrls.saveScmCart,
  };

  return handlePromise(apiPayload);
};

export const catalogBulkUpload = (data) => {
  const apiPayload = {
    method: "POST",
    data,
    headers: { "Content-Type": "multipart/form-data" },
    url: Env.getTeamCommonUrl() + apiUrls.scmBulkUpload,
  };

  return handlePromise(apiPayload);
};
